<template>
  <div>
    <top-menu
      ref="top-menu"
      @search="changeDate"
      @logout="$emit('logout')"
    />
    <v-tabs
      v-model="activeTab"
      align-tabs="center"
      fixed-tabs
      show-arrows
      :slider-color="themeClasses.color"
      class="top-tab v-theme--light v-tabs-bar"
    >
      <v-tab
        :to="{ path: 'list', query: { date: $route.query.date }}"
        class="ma-0"
      >
        予約一覧
      </v-tab>
      <v-tab
        v-for="(room) in firstReservationList.rooms"
        :key="room.section"
        class="ma-0"
        @click="changeTab(room)"
      >
        {{ room.name }}
      </v-tab>
    </v-tabs>
    <v-container
      fluid
      class="pa-0"
    >
      <v-row
        class="mt-0"
        justify="center"
      >
        <v-col class="pt-0 pb-0">
          <router-view v-slot="{ Component }">
            <v-fade-transition mode="out-in">
              <component :is="Component" />
            </v-fade-transition>
          </router-view>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TopMenu from "./shared/TopMenu.vue";
import environmentMixin from "../mixins/environment.js";
import {
  createRiskAssessmentDraftStore,
  RISK_ASSESSMENT_DRAFT_STORE_KEY
} from "@/vue/features/risk-assessment-input";

export default {
  name: "Tab",
  components: {
    TopMenu
  },
  mixins: [environmentMixin],
  // 夜間相談の画面内にいる間だけ、リスクアセスメントの入力途中の内容を相談ごとに保持する。
  provide() {
    return { [RISK_ASSESSMENT_DRAFT_STORE_KEY]: createRiskAssessmentDraftStore("夜間相談") };
  },
  emits: ["logout"],
  data: () => ({
    activeTab: "/reservations/list"
  }),
  computed: {
    ...mapGetters(["users", "firstReservationList"]),
  },
  watch: {
    "$route" () {
      this.$store.dispatch("fetchFirstReservationsOfDay", {
        date: this.$route.query.date
      }).then(() => {
        this.findTabIndex();
      });
    }
  },
  created() {
    this.$store.dispatch("fetchFirstReservationsOfDay", {
      date: this.$route.query.date
    }).then(() => {
      this.findTabIndex();
    });
  },
  methods: {
    changeDate(d) {
      this.$router.push({ name: "list", query: { date: d, reservation_id: "" } });
    },
    changeTab: function(room){
      this.$router.push({ name: "karte", query: { room: room.section, date: this.$route.query.date, reservation_id: this.firstReservationList.reservations[room.section] }});
    },
    findTabIndex: function(){
      if(this.$route.name == "karte"){
        var index = this.firstReservationList.rooms.findIndex(room => room.section == this.$route.query.room) + 1;
        this.activeTab = index;
      } else {
        this.activeTab = 0;
      }
    },
  },
};
</script>
<style lang="scss">
.top-tab {
  .v-btn:not(.v-tab--selected){
    .v-btn__content {
      color: rgb(0 0 0 / 0.54) !important;
    }
  }
}
</style>
